import { useMutation } from 'react-query';
import { SubscriptionApi } from '../api/subscription.api';

export const useRenewSubscription = () => {
  return useMutation(
    async () => {
      return await SubscriptionApi.resubscribeCurrentPlan();
    },
    {
      onSuccess: () => {
        window.location.reload();
      },
    }
  );
};
